<template>
  <div class="app-container">
    <HeaderLogo />
    <div class="main-content">
      <div class="card">
        <div class="alarm-header">
          <div>
            <div class="sub-title">终端报警事件记录</div>
            <div class="main-title">{{ group.name }}</div>
          </div>
          <div class="right-actions">
            <span class="link-back" @click="$router.back()">返回到上一页</span>
        
          </div>
        </div>

        <!-- Alarm Popup -->
        <transition name="fade">
          <div v-if="showAlert" class="alert-popup">
            <div class="alert-message">
              <button class="close-btn" @click="closeAlert">×</button> <!-- Close button -->
              <h4>报警信息</h4>
              <p><strong>告警类型：</strong>{{ alertInfo.type }}</p>
              <p><strong>设备名称：</strong>{{ alertInfo.device }}</p>
            
              <p><strong>发生时间：</strong>{{ alertInfo.time }}</p>
              <p><strong>详情：</strong>{{ alertInfo.details }}</p>
            </div>
          </div>
        </transition>

        <div class="table-wrapper">
          <table class="table">
            <thead>
              <tr>
                <th>终端序号</th>
                <th>宿舍名称</th>
             
                <th>记录时间</th>
                <th>告警类别</th>
                <th>告警信息</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in records" :key="index">
                <td>{{ row.deviceId }}</td>
                <td>{{ row.deviceName }}</td>
                <td>{{ row.alarmTime}}</td>
                <td>{{ row.alarmType
 }}</td>
                <td>{{ row.alarmMessage }}</td>
           
              </tr>
              <tr v-if="records.length === 0">
                <td colspan="6">暂无报警记录</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderLogo from '@/components/HeaderLogo.vue'
import { getDeviceAlarms } from '@/api/api'
export default {
  name: 'AlarmRecords',
  components: { HeaderLogo },
  props: {
    group: {
      type: Object,
      default: () => ({}) // 默认值设置为一个空对象
    }
  },
  data() {
    return {
      records: []
    }
  },
  methods: {
    refresh() {
      // 显示报警弹窗
      this.showAlert = true;
    },
    closeAlert() {
      this.showAlert = false;  // 手动关闭弹窗
    },

    async getDeviceAlarmList() {
  try {
   

    const res = await getDeviceAlarms();
    if (res.code === 0 && Array.isArray(res.data)) {
       this.records = res.data
    }
  } catch (err) {
    console.error('获取失败:', err);
  }
},
  },
   mounted() {
    this.getDeviceAlarmList()
  },
}
</script>

<style scoped>
.alarm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  gap: 12px;
  color: #e5e7eb;
}

.sub-title {
  font-size: 12px;
  color: #9ca3af;
}

.main-title {
  font-size: 19px;
  font-weight: 600;
  color: #f9fafb;
}

.right-actions {
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 10px;
}

.title {
  white-space: nowrap;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 8px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th, .table td {
  padding: 12px;
  text-align: center; /* 水平居中 */
}

.table th {
  font-weight: bold; /* 表头加粗 */
}

.alert-popup {
  position: fixed;
  top: 20px;
  left: 20px; /* Move to the left upper corner */
  background: linear-gradient(145deg, #dc3545, #ff5e62); /* Gradient background */
  color: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1); /* Subtle shadow for a 3D effect */
  width: 300px;
  max-width: 100%;
  transition: all 0.3s ease; /* Smooth transition */
}

.alert-message {
  font-size: 16px;
}

.alert-message h4 {
  margin-bottom: 10px;
  font-weight: bold;
}

.alert-message p {
  margin: 5px 0;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 18px;
  color: white;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 50%; /* Circular button */
  padding: 5px;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2); /* Hover effect */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease; /* Shorter and faster transition */
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: scale(0.95); /* Smooth scale effect */
}

@media (max-width: 768px) {
  .alarm-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .right-actions {
    align-self: stretch;
    justify-content: space-between;
  }
  .right-actions .btn {
    flex-shrink: 0;
  }
  /* Ensure tables are scrollable horizontally on smaller screens */
  .table-wrapper {
    overflow-x: scroll;
  }
}
</style>
